import { CategoryManager } from "./CategoryManager";

export function CategoriesSection() {
  return <CategoryManager />;
}
